import { render } from "./SearchWorkshopReadyOrders.vue?vue&type=template&id=4b3ae5c8"
import script from "./SearchWorkshopReadyOrders.vue?vue&type=script&lang=js"
export * from "./SearchWorkshopReadyOrders.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__